import { CoordinatorService } from "./coordinator.service"
import { ExternalWeb } from "./external-web"

export class ExternalWeb$ {

    private _webMap = new Map<string, ExternalWeb>();


    constructor(private coords: CoordinatorService) {
    }

    onStart() {
        console.log("ExternalWeb.onStart")
        new ExternalWeb(this.coords, {
            tag: "scholar",
            title: "Google Scholar",
            url: "https://scholar.google.com/scholar?q=${term}"
        })

        new ExternalWeb(this.coords, {
            tag: "pubmed",
            title: "PubMed",
            url: "https://pubmed.ncbi.nlm.nih.gov/?term=${term}"
        })

        new ExternalWeb(this.coords, {
            tag: "gate",
            title: "Research Gate",
            url: "https://www.researchgate.net/search/publication?q=${term}"
        })

        new ExternalWeb(this.coords, {
            tag: "dimensions",
            title: "Dimensions",
            url: "https://app.dimensions.ai/discover/publication?search_text=${term}"
        })

        new ExternalWeb(this.coords, {
            tag: "semscholar",
            title: "Semantic Scholar",
            url: "https://www.semanticscholar.org/search?q=${term}"
        })

        new ExternalWeb(this.coords, {
            tag: "core",
            title: "Core",
            url: "https://core.ac.uk/search?q=${term}"
        })

        new ExternalWeb(this.coords, {
            tag: "base",
            title: "Base",
            url: "https://www.base-search.net/Search/Results?lookfor=${term}"
        })

        new ExternalWeb(this.coords, {
            tag: "google",
            title: "Google",
            url: "https://www.google.com/search?q=${term}"
        })

        new ExternalWeb(this.coords, {
            tag: "duck",
            title: "DuckDuckGo",
            url: "https://duckduckgo.com/?q=${term}"
        })

        new ExternalWeb(this.coords, {
            tag: "bing",
            title: "Bing",
            url: "https://www.bing.com/search?q=${term}"
        })
    }

    run(tag: string, term: string) {
        this._webMap.get(tag)?.run(term)
    }

    add(ew: ExternalWeb) {
        this._webMap.set(ew.tag, ew)
    }

    open(url: string, windowName = "_blank") {
        const a = document.createElement("a")
        a.href = url
        a.target = windowName
        a.rel = "noopener"
        // a.rel = "noopener noreferrer nofollow" 
        a.click()
    }

    tbli() {
        return this.coords.table$.createTableInstance({
            origin: this,
            templateId: "external-web"
        })
    }


    get tableTemplate() {
        return {
            id: "external-web",
            tagLs: Array.from(this._webMap.values())
                .map(x => ({ tag: x.tag, label: x.title }))
        }
    }

    get(tag: string) {
        return this._webMap.get(tag)?.a()
    }
}
